module.exports = __webpack_public_path__ + "img/BigV.638b760c.jpeg";